import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators, FormBuilder, FormsModule, ReactiveFormsModule, FormArray } from '@angular/forms';
import { ApiServiceService } from '../service/api-service.service';
import { configuration } from 'src/configuration';
import { SharedService } from '../service/shared.service';
import { Editor } from 'ngx-editor';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-create-property',
  templateUrl: './create-property.component.html',
  styleUrls: ['./create-property.component.css']
})
export class CreatePropertyComponent implements OnInit, OnDestroy {
  AddInfosubmit= false;
  Anmenitiessubmit= false;
  resalesubmit = false;
  landmarksubmit = false;
  proertydetailssubmit = false;
  submit = false;
  activeTab: any = 'property_details'
  currentPropertyId: any = ''
  addressList: any = []
  cityList: any = []
  landmarkListMain: any = []
  landmarkList: any = []
  propertyImages: any = [];
  communityImages: any = [];
  residentialImages: any = [];
  _propertyImages: any = [];
  _communityImages: any = [];
  existingcommunityImages: any = [];
  _residentialImages: any = [];
  isImageError: any = false;
  isgallaryFormSubmit: any = false
  isRemarkModal: any = false
  isDropdownOpen: boolean = false;
  selectedOption: string = ''; // Assuming 'propertyTypes' is an array of strings
  selected_property_type_id: any;
  is_next_step_allow: any = false
  selectedCityId: any = null
  selectedLandmarkId: any = null
  showOthersModal: boolean = false;
  propertyTypes: string[] = ['Apartment', 'Villa', 'Townhouse'];
  numberofbedroom: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '7+'];
  numberOfBathrooms: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '7+'];
  cityOptions: any = []
  landmarkOptions: string[] = ['Landmark 1', 'Landmark 2', 'Landmark 3'];
  waterSupplyOptions: string[] = ['Option 1', 'Option 2', 'Option 3'];
  electricityConnectionOptions: string[] = ['Option 1', 'Option 2', 'Option 3'];
  sewageConnectionOptions: string[] = ['Option 1', 'Option 2', 'Option 3'];
  isAllStepDone : any = false
  deedImages: any = [];
  floorImages: any = [];

  currentStep: any = 6

  entranceImages: any = [];
  livingRoomImages: any = [];
  kitchenImages: any = [];
  washroomImages: any = [];
  bedroomImages1: any = [];
  bedroomImages2: any = [];
  bedroomImages3: any = [];
  bedroomImages4: any = [];
  bedroomImages5: any = [];
  bedroomImages6: any = [];
  bedroomImages7: any = [];
  bedroomImages8: any = [];
  brochureImages: any = [];

  [propertyName: string]: any;

  bedroomImageCategory: any;

  showOthersCard: boolean = false;
  is_deed_image_err : any = false
  is_floor_plan_err : any = false
  is_terms_modal : any = false;
  is_edit_property : any = false
  currentPropertyData : any = null
  isCityDropdownOpen: boolean = false;
  citySelectedOption: any = {};
  isLandmarkDropdownOpen: boolean = false;
  landmarkSelectedOption: any = {};
  existingEntranceImages : any = []
  is_step2_submit : any = false;


  quarterlyOptions: string[] = ['Q1', 'Q2', 'Q3', 'Q4'];
  selectedQuarterly: string = '';
  isDropdown1: boolean = false;
  isDropdown2: boolean = false;
  activeDropdown: string = ''; // Track active dropdown

  yearOptions: any = [];
  selectedYear: any;
  locationOptions : any = []
  isAddressDropdownOpen : any = false
  selectedAddressLat: any;
  selectedAddressLong: any;

  adminUserID = environment.ADMIN_USER_ID;

  // Property Details
  proertydetailsForm: any = new FormGroup({
    project_name: new FormControl(''),
    tagline: new FormControl('', [Validators.required]),
    goverment_fee: new FormControl('', [Validators.required]),
    // delivery_date: new FormControl('', [Validators.required]),
    plot_area: new FormControl('', [Validators.required]),
    plot_size: new FormControl(''),
    selling_type: new FormControl('2'),
    property_construction_type: new FormControl('1', [Validators.required]),
    // handover_date: new FormControl(''),
    other_property_type: new FormControl(''),
    property_features: new FormArray([]),
    property_features_2: new FormArray([]),
    property_highlight: new FormArray([]),
    description: new FormControl(),
  });

  // Locality Details
  localityForm = new FormGroup({
    address: new FormControl('', [Validators.required]),
    is_title_deed_certificate: new FormControl('0'),
    is_spa: new FormControl('0'),
    ownership_type: new FormControl('1'),
  });

// Resale Details
resaleForm = new FormGroup({
  price: new FormControl('', [Validators.required]),
  is_price_negotiable: new FormControl(false),
  is_under_loan: new FormControl(false),
  resale_description: new FormControl(''),
  available_from: new FormControl(''),
  is_rent: new FormControl('0'),
  is_payment_type: new FormControl('3'),
  is_tainted: new FormControl(false),
});

  amenitiesForm : any = new FormGroup({
    furnished_type: new FormControl('Furnished'),
    balcony: new FormControl('Yes'),
    equipped_kitchen: new FormControl('Yes'),
    no_of_parking: new FormControl('0'),
    maids_room: new FormControl('Yes'),
    pool: new FormControl('Yes'),
    gym: new FormControl('Yes'),
    pets_allowed: new FormControl('Yes'),
    children_play_area: new FormControl('Yes'),
    walk_in_closet: new FormControl('Yes'),
  })

  // Gallary
  gallaryForm: any = new FormGroup({
    category_type: new FormControl('1'),
    upload_via_phone: new FormControl('Upload through Phone', [Validators.required]),
  })

  // Additional Information
  addinfoForm = new FormGroup({
    is_title_deed_certificate: new FormControl('0', [Validators.required]),
    is_spa: new FormControl('0', [Validators.required]),
    ownership_type: new FormControl('1', [Validators.required]),
  })

  featuresData = [
    { id: 'Upgraded', name: 'Upgraded' },
    { id: 'Duplex', name: 'Duplex' },
    { id: 'Penthouse', name: 'Penthouse' },
    { id: 'Owner Occupied', name: 'Owner Occupied' },
    // { id: 'Contemporary', name: 'Contemporary' },
    { id: 'Maids Room', name: 'Maids Room' },
    { id: 'Tenant Occupied', name: 'Tenant Occupied' },

    { id: 'Chiller Free', name: 'Chiller Free' },
    { id: 'Brand New', name: 'Brand New' },
    { id: 'Ready to Move In', name: 'Ready to Move In' },
    { id: 'Corner Unit', name: 'Corner Unit' },
  ];

  featuresDataOffPlan = [
    { id: 'offplan Standalone Villa', name: 'Standalone Villa' },
    { id: 'offplan Single Row Villa', name: 'Single Row Villa' },
    { id: 'offplan Back to back Villa', name: 'Back to Back Villa' },
    { id: 'offplan Maids Room', name: 'Maids Room' },
    { id: 'offplan Chiller Free', name: 'Chiller Free' },
  ];

  editor!: Editor;
  html = '';
  user_type:any = '';
  subscriptionInfo = null;

  constructor(private fb: FormBuilder, private router: Router, public apiService: ApiServiceService, public shared: SharedService,public route: ActivatedRoute) {
    const id: string = route.snapshot.params['id'];
    // console.log("id",id)      
    if(this.shared.isBrowser()) {
      this.user_type = localStorage.getItem(configuration.LOCAL_STORAGE.USER_TYPE);
    } 

    if(id) {
      this.currentPropertyId = id;
      this.is_edit_property = true
      this.subscriptionInfo = {
        result: true,
        hasSubscription: true
      }
      this.getPropetyData();
    } else {
      this.checkAccessToAddProperty();
    }
    this.shared.isWhiteMenu = true;
    this.addFeaturesCheckboxes();
    this.addFeaturesCheckboxes2();
    this.addNextYears()
  }

  ngOnInit(): void {
    this.editor = new Editor();
    this.bedroomImageCategory = [
      {
        "id": 1,
        "name": "Bedroom 1"
      },
      {
        "id": 2,
        "name": "Bedroom 2"
      },
      {
        "id": 3,
        "name": "Bedroom 3"
      },
      {
        "id": 4,
        "name": "Bedroom 4"
      },
      {
        "id": 5,
        "name": "Bedroom 5"
      },
      {
        "id": 6,
        "name": "Bedroom 6"
      },
      {
        "id": 7,
        "name": "Bedroom 7"
      },
      {
        "id": 8,
        "name": "Other Bedrooms"
      },
    ]
    this.getData();
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  async checkAccessToAddProperty() {
    let res = await this.apiService.GET_apiRequest(configuration.ENDPOINT.CAN_POST_PROPERTY); 
    if(res && res.data) {
      this.subscriptionInfo = res.data;
    }
  }

  addNextYears() {
    let date = new Date()
    let currentYear = date.getFullYear()
    this.selectedYear = currentYear

    for (let i = this.selectedYear; this.yearOptions.length <= 10; i++) {
      this.yearOptions.push(i)
    }
  }
  
  async getPropetyData() {
    let res = await this.apiService.GET_apiRequest(configuration.ENDPOINT.PROPERTY_VIEW + "/" + this.currentPropertyId);
    if (res && !res.error && res.data) {
      this.currentPropertyData = res.data;
      console.log("this.currentPropertyData", this.currentPropertyData)
      this.proertydetailsForm.patchValue({
        selling_type: this.currentPropertyData.selling_type == 2 ? '2' : '1',
        plot_area: this.currentPropertyData.plot_area,
        description: this.currentPropertyData.resale_description,
      })
      this.html = this.currentPropertyData.resale_description;
      console.log(this.html);
      this.localityForm.patchValue({
        address: this.currentPropertyData.address
      })

      this.selectedAddressLat = this.currentPropertyData.address_lat
      this.selectedAddressLong = this.currentPropertyData.address_log

      this.selectedCityId = this.currentPropertyData.city_id
      this.citySelectedOption['city_name'] = this.currentPropertyData.PropertyToMasterCityData.city_name
      this.citySelectedOption['id'] = this.currentPropertyData.city_id

      this.selectedLandmarkId = this.currentPropertyData.landmark_id
      this.landmarkSelectedOption['landmark_name'] = this.currentPropertyData.PropertyToMasterLandmarkData ? this.currentPropertyData.PropertyToMasterLandmarkData.landmark_name : ""
      this.landmarkSelectedOption['id'] = this.currentPropertyData.landmark_id

      this.selected_property_type_id = this.currentPropertyData.property_type_id
      this.selectedOption = "";
      if(this.currentPropertyData.PropertyToMasterPropertyTypeData) {
        this.selectedOption = this.currentPropertyData.PropertyToMasterPropertyTypeData.property_type
      }
      this.bedroomSelectedOption = this.currentPropertyData.no_of_bedrooms
      this.bathroomSelectedOption = this.currentPropertyData.no_of_bathrooms

      console.log("this.currentPropertyData.selling_type", this.currentPropertyData.selling_type);
      if (this.currentPropertyData.selling_type == 1) {
        this.proertydetailsForm.patchValue({
          property_construction_type: this.currentPropertyData.property_construction_type == 1 ? '1' : '2',
        })
      }

      if (this.currentPropertyData.property_construction_type == 2) {
        this.proertydetailsForm.patchValue({
          // handover_date: this.currentPropertyData.handover_date,
          project_name : this.currentPropertyData.property_name
        })

        this.selectedQuarterly = this.currentPropertyData.handover_quarter
        this.selectedYear = this.currentPropertyData.handover_year
      }
      this.proertydetailsForm.patchValue({
        // handover_date: this.currentPropertyData.handover_date,
        tagline : this.currentPropertyData.tagline
      })

      this.proertydetailsForm.patchValue({
        goverment_fee : this.currentPropertyData.government_fee
      })

      
      

      if(this.currentPropertyData.property_features) {
        if (this.currentPropertyData.selling_type == 1 && this.currentPropertyData.property_construction_type == 2) {
          const selectedFeatures = this.currentPropertyData.property_features.split(',');
          selectedFeatures.forEach((feature: any) => {
            console.log("feature",feature)
            const index = this.featuresDataOffPlan.findIndex(data => data.id === feature);
            if (index !== -1) {
              this.featuresFormArray2.at(index).patchValue(true);
            }
          });
        } else {
          const selectedFeatures = this.currentPropertyData.property_features.split(',');
          selectedFeatures.forEach((feature: any) => {
            const index = this.featuresData.findIndex(data => data.id === feature);
            if (index !== -1) {
              this.featuresFormArray.at(index).patchValue(true);
            }
          });
        }
      }


      if (this.currentPropertyData.property_type_id == 2 || this.currentPropertyData.property_type_id == 3) {
        this.proertydetailsForm.patchValue({
          plot_size: this.currentPropertyData.plot_size
        })
      }

      if (this.currentPropertyData.selling_type == '1') {
        this.localityForm.patchValue({
          ownership_type: this.currentPropertyData.ownership_type == 1 ? '1' : '2'
        })
      }

      if (this.currentPropertyData.deed_images) {
        console.log("this.currentPropertyData.deed_images",this.currentPropertyData.deed_images)
        if (this.currentPropertyData.deed_images.includes(',')) {
          for (let i of this.currentPropertyData.deed_images.split(',')) {
            if(this.isPDFFile(i)){
              this.deedImages.push({
                result: i,
                fromAPI : true,
                isImage : false
              })
            }else if(this.isImageFile(i)){
              this.deedImages.push({
                result: i,
                fromAPI : true,
                isImage : true
              })
            }
          }
        } else {
          if(this.isPDFFile(this.currentPropertyData.deed_images)){
            this.deedImages.push({
              result: this.currentPropertyData.deed_images,
              fromAPI : true,
              isImage : false
            })
          }else{
            this.deedImages.push({
              result: this.currentPropertyData.deed_images,
              fromAPI : true,
              isImage : true
            })
          }          
        }
      }

      if (this.currentPropertyData.floor_plan) {
        if (this.currentPropertyData.floor_plan.includes(',')) {
          for (let i of this.currentPropertyData.floor_plan.split(',')) {
            this.floorImages.push({
              result: i,
              fromAPI : true,
              isImage : false
            })
          }
        } else {
          this.floorImages.push({
            result: this.currentPropertyData.floor_plan,
            fromAPI : true,
            isImage : false
          })
        }
      }

      this.resaleForm.patchValue({
        price: this.currentPropertyData.price,
        is_payment_type: String(this.currentPropertyData.payment_type),
        available_from: this.currentPropertyData.available_from
      })

      if (this.currentPropertyData.selling_type == '1') {
        this.resaleForm.patchValue({
          is_price_negotiable: this.currentPropertyData.is_price_negotiable == true ? true : false,
          is_under_loan: this.currentPropertyData.is_mortgaged == true ? true : false,
          is_tainted: this.currentPropertyData.is_tainted == true ? true : false,
        })
      }

      if (this.currentPropertyData.amenities_json) {
        let amenities = JSON.parse(this.currentPropertyData.amenities_json)
        for (let i in amenities) {
          if (this.amenitiesForm.get(i)) {
            this.amenitiesForm.get(i).setValue(amenities[i]);
          }
        }
      }

      if(this.currentPropertyData.selling_type == '1' && this.currentPropertyData.property_construction_type == 2){
        this.brochureImages = this.getImageArr(this.currentPropertyData.brochure)
      }

      if (this.currentPropertyData.PropertyToPropertyMediaData && this.currentPropertyData.PropertyToPropertyMediaData.length > 0) {
        for (let i of this.currentPropertyData.PropertyToPropertyMediaData) {
          console.log("i", i)
          if (i.category_type == 1) {
            this.entranceImages = this.getImageArr(i.images)
          }else if (i.category_type == 2) {
            this.livingRoomImages = this.getImageArr(i.images)
          } else if (i.category_type == 3) {
            this.kitchenImages = this.getImageArr(i.images)
          } else if (i.category_type == 4) {
            this.bedroomImages1 = this.getImageArr(i.images)
          } else if (i.category_type == 5) {
            this.bedroomImages2 = this.getImageArr(i.images)
          } else if (i.category_type == 6) {
            this.bedroomImages3 = this.getImageArr(i.images)
          } else if (i.category_type == 7) {
            this.bedroomImages4 = this.getImageArr(i.images)
          } else if (i.category_type == 8) {
            this.bedroomImages5 = this.getImageArr(i.images)
          } else if (i.category_type == 9) {
            this.bedroomImages6 = this.getImageArr(i.images)
          } else if (i.category_type == 10) {
            this.bedroomImages7 = this.getImageArr(i.images)
          } else if (i.category_type == 11) {
            this.bedroomImages8 = this.getImageArr(i.images)
          }
          else if (i.category_type == 12) {
            this.washroomImages = this.getImageArr(i.images)
          }else if (i.category_type == 14) {
            this.communityImages = this.getImageArr(i.images)
          }
        }
      }
      console.log("this.entranceImages",this.entranceImages)
    }
  }
  
  isPDFFile(file: any) {
    return file.split('.').pop().toLowerCase() === 'pdf';
  }

  isImageFile(file: any) {
    return ['jpg', 'jpeg', 'png', 'gif'].includes(file.split('.').pop().toLowerCase());
  }

  openImage(image : any){
    window.open(this.shared.getImageURL(image), "_blank");
  }

  getImageArr(imageArr: any) {
    let arr = []
    if (imageArr && imageArr.includes(',')) {
      for (let i of imageArr.split(',')) {
        if (i) {
          arr.push({
            result: i,
            fromAPI: true
          })
        }
      }
    } else {
      arr.push({
        result: imageArr,
        fromAPI: true
      })
    }
    return arr
  }

  openModal() {
    // Add logic here to open your modal
    // For example, you can use a modal service or set a variable to control modal visibility
    console.log('Open your modal here');
  }
  get featuresFormArray() {
    return this.proertydetailsForm.controls.property_features as FormArray;
  }

  get featuresFormArray2() {
    return this.proertydetailsForm.controls.property_features_2 as FormArray;
  }

  get highlightsFormArray() {
    return this.proertydetailsForm.controls.property_highlight as FormArray;
  }

  get detailsFormArray() {
    return this.proertydetailsForm.controls.property_details as FormArray;
  }

  private addFeaturesCheckboxes() {
    this.featuresData.forEach(() => this.featuresFormArray.push(new FormControl(false)));
  }

  private addFeaturesCheckboxes2() {
    this.featuresDataOffPlan.forEach(() => this.featuresFormArray2.push(new FormControl(false)));
  }

  // private addHighlightsCheckboxes() {
  //   this.highlightsData.forEach(() => this.highlightsFormArray.push(new FormControl(false)));
  // }

  // private addDetailsCheckboxes() {
  //   this.detailsData.forEach(() => this.detailsFormArray.push(new FormControl(false)));
  // }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  selectOption(option: string, index: any): void {
    this.selected_property_type_id = index;
    this.selectedOption = option;
    this.isDropdownOpen = false;

    // Add logic to toggle the card when "Others" is selected
    this.showOthersCard = (option === 'Others');
  }

  onDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.type-dropdown');
    if (!dropdown.contains(event.target as Node)) {
      this.isDropdownOpen = false;
    }
  }



  isBedroomDropdownOpen: boolean = false;
  bedroomSelectedOption: string = '';

  toggleBedroomDropdown(): void {
    this.isBedroomDropdownOpen = !this.isBedroomDropdownOpen;
  }

  selectBedroomOption(option: string): void {
    this.bedroomSelectedOption = option;
    this.isBedroomDropdownOpen = false;
  }

  onBedroomDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.bedroom-dropdown'); // Add a class to your bedroom dropdown
    if (!dropdown.contains(event.target as Node)) {
      this.isBedroomDropdownOpen = false;
    }
  }

  // Bathroom Dropdown
  isBathroomDropdownOpen: boolean = false;
  bathroomSelectedOption: string = '';

  toggleBathroomDropdown(): void {
    this.isBathroomDropdownOpen = !this.isBathroomDropdownOpen;
  }

  selectBathroomOption(option: string): void {
    this.bathroomSelectedOption = option;
    this.isBathroomDropdownOpen = false;
  }

  onBathroomDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.bathroom-dropdown'); // Add a class to your bathroom dropdown
    if (!dropdown.contains(event.target as Node)) {
      this.isBathroomDropdownOpen = false;
    }
  }


  

  toggleCityDropdown(): void {
    this.isCityDropdownOpen = !this.isCityDropdownOpen;
  }

  async selectCityOption(option: any): Promise<void> {
    console.log("option",option)
    this.citySelectedOption = option;
    this.selectedCityId = option.id
    this.isCityDropdownOpen = false;
    let res = await this.apiService.GET_apiRequest(configuration.ENDPOINT.LANDMARK_LIST_CITY_WISE + "/" + this.selectedCityId);
    if (res && !res.error && res.data && res.data.rows) {
      this.landmarkListMain = res.data.rows
      this.landmarkList = res.data.rows
    }
  }

  onCityDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.city-dropdown'); // Add a class to your city dropdown
    if (!dropdown.contains(event.target as Node)) {
      this.isCityDropdownOpen = false;
    }
  }

  onAddressDocumentClick(event: MouseEvent) : void{
    const dropdown: any = document.querySelector('.address-dropdown'); // Add a class to your city dropdown
    if (!dropdown.contains(event.target as Node)) {
      this.isAddressDropdownOpen = false;
    }
  }


  toggleLandmarkDropdown(): void {
    this.isLandmarkDropdownOpen = !this.isLandmarkDropdownOpen;
  }

  selectLandmarkOption(option: any): void {
    this.landmarkSelectedOption = option;
    this.selectedLandmarkId = option.id
    this.isLandmarkDropdownOpen = false;
  }

  onLandmarkDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.landmark-dropdown'); // Add a class to your landmark dropdown
    if (!dropdown.contains(event.target as Node)) {
      this.isLandmarkDropdownOpen = false;
    }
  }

  isWaterSupplyDropdownOpen: boolean = false;
  waterSupplySelectedOption: string = '';

  toggleWaterSupplyDropdown(): void {
    this.isWaterSupplyDropdownOpen = !this.isWaterSupplyDropdownOpen;
  }

  selectWaterSupplyOption(option: string): void {
    this.waterSupplySelectedOption = option;
    this.isWaterSupplyDropdownOpen = false;
  }

  onWaterSupplyDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.water-supply-dropdown'); // Add a class to your water supply dropdown
    if (!dropdown.contains(event.target as Node)) {
      this.isWaterSupplyDropdownOpen = false;
    }
  }

  isElectricityConnectionDropdownOpen: boolean = false;
  electricityConnectionSelectedOption: string = '';

  toggleElectricityConnectionDropdown(): void {
    this.isElectricityConnectionDropdownOpen = !this.isElectricityConnectionDropdownOpen;
  }

  selectElectricityConnectionOption(option: string): void {
    this.electricityConnectionSelectedOption = option;
    this.isElectricityConnectionDropdownOpen = false;
  }

  onElectricityConnectionDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.electricity-connection-dropdown'); // Add a class to your electricity connection dropdown
    if (!dropdown.contains(event.target as Node)) {
      this.isElectricityConnectionDropdownOpen = false;
    }
  }

  isSewageConnectionDropdownOpen: boolean = false;
  sewageConnectionSelectedOption: string = '';

  toggleSewageConnectionDropdown(): void {
    this.isSewageConnectionDropdownOpen = !this.isSewageConnectionDropdownOpen;
  }

  selectSewageConnectionOption(option: string): void {
    this.sewageConnectionSelectedOption = option;
    this.isSewageConnectionDropdownOpen = false;
  }

  onSewageConnectionDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.sewage-connection-dropdown'); // Add a class to your sewage connection dropdown
    if (!dropdown.contains(event.target as Node)) {
      this.isSewageConnectionDropdownOpen = false;
    }
  }

  toggleHandover2(): void {
    this.isDropdown2 = !this.isDropdown2;
  }

  toggleHandover1(): void {
    this.isDropdown1 = !this.isDropdown1;
  }
  
  selectQuarterly(quarterly: string, index: number): void {
    this.selectedQuarterly = quarterly;
    this.toggleHandover1(); 
  }
  
  selectYear(year: number, index: number): void {
    this.selectedYear = year;
    this.toggleHandover2(); // Call the toggleHandover function
  }
  
  onDocument(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.custom-dropdown');
    if (!dropdown.contains(event.target as Node)) {
      this.isDropdown1 = false;
    }
  }

  onDocumentYear(event: MouseEvent): void {

    const dropdown_year: any = document.querySelector('.custom-dropdown-year');
    if (!dropdown_year.contains(event.target as Node)) {
      this.isDropdown2 = false;
    }
  }
  
  
 

  onRemark() {
    this.isRemarkModal = true;
  }
  closeRemarkModal() {
    this.isRemarkModal = false
  }

  closeotherModalName() {
    this.showOthersModal = false
  }
  async onSubmitproperty_details() {
    let is_error: any = false
    let is_valid : any = true
    this.proertydetailssubmit = true;
    console.log(this.proertydetailsForm.value);
    console.log("this.proertydetailsForm.valid", this.proertydetailsForm.valid)
    this.proertydetailsForm.patchValue({
      description: this.html,
    })
    if (this.proertydetailsForm.value.property_construction_type == 2) {
      if (this.selectedYear == '' || this.selectedQuarterly == '' || this.proertydetailsForm.value.project_name == '') {
        is_valid = false
      }
    }
    if (this.proertydetailsForm.valid && is_valid) {
      this.shared.isLoader = true
      const selectedFeatures = this.proertydetailsForm.value.property_features
        .map((checked: any, i: any) => checked ? this.featuresData[i].id : null)
        .filter((v: null) => v !== null);
      const selectedOffPlanFeatures = this.proertydetailsForm.value.property_features_2
        .map((checked: any, i: any) => checked ? this.featuresDataOffPlan[i].id : null)
        .filter((v: null) => v !== null);

      let json = {
        "selling_type": this.proertydetailsForm.value.selling_type,
        "property_construction_type": this.proertydetailsForm.value.selling_type == 1 ? this.proertydetailsForm.value.property_construction_type : null,
        // "handover_date": this.proertydetailsForm.value.property_construction_type == 2 ? this.proertydetailsForm.value.handover_date : null,
        "handover_quarter": this.proertydetailsForm.value.property_construction_type == 2 ? this.selectedQuarterly : null,
        "handover_year": this.proertydetailsForm.value.property_construction_type == 2 ? this.selectedYear : null,  
        "property_type_id": this.selected_property_type_id,
        "other_property_type": this.selected_property_type_id == 5 ? this.proertydetailsForm.value.other_property_type : null,
        "no_of_bathrooms": this.bathroomSelectedOption,
        "no_of_bedrooms": this.bedroomSelectedOption,
        "property_features": this.proertydetailsForm.value.selling_type == 1 && this.proertydetailsForm.value.property_construction_type == 2 ? selectedOffPlanFeatures.join(",") : selectedFeatures.join(","),
        "plot_area": this.proertydetailsForm.value.plot_area,
        "plot_size": this.proertydetailsForm.value.plot_size ? this.proertydetailsForm.value.plot_size : null,
        "resale_description": this.proertydetailsForm.value.description,
        "tagline": this.proertydetailsForm.value.tagline, 
        // "delivery_date": this.proertydetailsForm.value.delivery_date,        
        "goverment_fee": this.proertydetailsForm.value.goverment_fee,        
        "property_name": this.proertydetailsForm.value.property_construction_type == 2 ? this.proertydetailsForm.value.project_name : null,
      }
      this.proertydetailssubmit = false;
      if (this.currentPropertyId) {
        let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.UPDATE_PROPERTY_STEP1 + this.currentPropertyId, json)
        if (res && !res.error) {
          is_error = false
        }
      } else {
        let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CREATE_PROPERTY_STEP1, json);
        if (res && !res.error && res.data) {
          this.currentPropertyId = res.data.id
          is_error = false
        } else if (res && res.error) {
          this.subscriptionInfo = res.data
        }
      }

      if (!is_error) {
        window.scrollTo(0, 0);
        this.shared.isLoader = false
        this.currentStep = 2
        this.activeTab = 'locality_details'
      }
    }
  }

  async onlandmark_details() {
    this.is_step2_submit = true
    this.is_deed_image_err = false
    this.is_floor_plan_err = false
    if (this.deedImages.length == 0) {
      this.is_deed_image_err = true
    }
    if(this.floorImages.length == 0){
      this.is_floor_plan_err = true
    }
    console.log("this.floorImages.length",this.floorImages.length)
    if(this.proertydetailsForm.value.property_construction_type == '2'){
      this.is_floor_plan_err = this.is_floor_plan_err
    }else{
      this.is_floor_plan_err = false
    }
    this.landmarksubmit = true;
    // console.log(this.localityForm.valid);
    // console.log("is_deed_image_err",this.is_deed_image_err)
    // console.log("is_floor_plan_err",this.is_floor_plan_err)
    // if (this.localityForm.valid && (this.deedImages.length != 0 || this.deedFiles.length != 0)  && !this.is_floor_plan_err) {
    if (this.localityForm.valid) {
      this.shared.isLoader = true
      let is_error: any;
      // this.landmarksubmit = true;
      // this.landmarksubmit = false;
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CREATE_PROPERTY_STEP2, {
        "id": this.currentPropertyId,
        "city_id": this.selectedCityId,
        "landmark_id": this.selectedLandmarkId,
        "address": this.localityForm.value.address,
        "address_lat": this.selectedAddressLat,
        "address_log": this.selectedAddressLong,
        "ownership_type": this.proertydetailsForm.value.selling_type == '1' ? this.localityForm.value.ownership_type : null
      });
      if (res && !res.error) {
        is_error = false
      } else {
        is_error = true
      }

      if (this.deedImages && this.deedImages.length > 0) {

        let files = this.deedImages
        const formData = new FormData();
        formData.append("property_id", this.currentPropertyId);
        for (let t of files) {
          formData.append("files", t.file);
        }
        this.apiService.isUploadImage = true;
        let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.UPLOAD_DEED_IMAGES, formData)
        if (res && !res.error) {
          is_error = false
        } else {
          is_error = true
        }
      }

      if (this.floorImages && this.floorImages.length > 0) {

        let files = this.floorImages
        console.log("files",files)
        const formData = new FormData();
        formData.append("property_id", this.currentPropertyId);
        for (let t of files) {
          if(t.file){
          formData.append("files", t.file);
          }
        }
        this.apiService.isUploadImage = true;
        let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.UPLOAD_FLOOR_IMAGES, formData)
        if (res && !res.error) {
          is_error = false
        } else {
          is_error = true
        }
      }

      if (!is_error) {
        this.is_step2_submit = false
        this.shared.isLoader = false
        this.currentStep = 3
        this.activeTab = 'resale_details'
      }

    }
  }
  async onTextareaChange(event: any) {
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_LOCATION_TEXT_AREA_DATA, {
      "location": event.target.value
    })
    // console.log(res)
    if (res) {
      this.locationOptions = res;
      this.isAddressDropdownOpen = true

    } else {
      this.locationOptions = []
    }
  }

  onLocationSelect(selectedValue: any) {
    console.log("selectedValue", selectedValue)
    this.isAddressDropdownOpen = false
    this.selectedAddressLat = selectedValue.latitude
    this.selectedAddressLong = selectedValue.longitude
    this.localityForm.get('address').setValue(selectedValue.label);
  }


  async onresale_details() {
    this.resalesubmit = true;
    console.log(this.resaleForm.value);
    if (this.resaleForm.valid) {
      this.shared.isLoader = true
      this.resalesubmit = false;
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CREATE_PROPERTY_STEP3, {
        "id": this.currentPropertyId,
        "price": this.resaleForm.value.price,
        "is_price_negotiable": this.resaleForm.value.is_price_negotiable == true ? 1 : 0, //Price Negotiable
        "available_from": this.resaleForm.value.available_from,
        "is_mortgaged": this.resaleForm.value.is_under_loan == true ? 1 : 0, // Mortgaged
        "payment_type": this.resaleForm.value.is_payment_type ? this.resaleForm.value.is_payment_type : null,
        "is_tainted": this.resaleForm.value.is_tainted == true ? 1 : 0, //Rented
      });
      if (res && !res.error) {
        this.shared.isLoader = false
        this.currentStep = 4
        this.activeTab = 'amenities'
      }
    }
  }

  //Amenities

  async onAnmenities_details() {
    this.Anmenitiessubmit = true;
    console.log(this.amenitiesForm.value);
    if (this.amenitiesForm.valid) {
      this.shared.isLoader = true
      this.Anmenitiessubmit = false;
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CREATE_PROPERTY_STEP4, {
        "property_id": this.currentPropertyId,
        "amenities_json" : JSON.stringify(this.amenitiesForm.value)
      });
      if (res && !res.error) {
        this.shared.isLoader = false
        this.currentStep = 5
        this.activeTab = 'gallary'
      }
    }
  }

  // Gallary
  async onGallary_details() {
    this.isgallaryFormSubmit = true;
    let error: any = false
    let isAllBedroomImages: any = false
    let availBedroomImageNames: any = []
    if (this.proertydetailsForm.value.property_construction_type == '2') {
      if (this.brochureImages.length > 0) {
        this.shared.isLoader = true
        let files = this.brochureImages
        const formData = new FormData();
        formData.append("property_id", this.currentPropertyId);
        for (let t of files) {
          formData.append("brochure", t.file);
        }
        this.apiService.isUploadImage = true;
        let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.UPLOAD_BROCHURE, formData)
        if (res && !res.error) {
          error = false
        }
      } else {
        error = true
      }
      if (this.entranceImages.length > 0) {
        let category_type: any;
          category_type = 1
          let files = this.entranceImages
          const formData = new FormData();
          formData.append("property_id", this.currentPropertyId);
          formData.append("category_type", category_type);
          for (let t of files) {
            formData.append("files", t.file);
          }
          this.apiService.isUploadImage = true;
          let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CREATE_PROPERTY_STEP5, formData)
          if (res && !res.error) {
            error = false
          }
      } else {
        error = true
      }
    } else {
      if (this.bedroomSelectedOption && this.bedroomSelectedOption.length > 0) {
        console.log("bedroomSelectedOption", this.bedroomSelectedOption)
        for (let i of this.bedroomImageCategory.slice(0, this.bedroomSelectedOption)) {
          console.log("i", i)
          if (this['bedroomImages' + i.id] && this['bedroomImages' + i.id].length > 0) {
            availBedroomImageNames.push('bedroomImages' + i.id)
            isAllBedroomImages = true
          } else {
            isAllBedroomImages = false
            availBedroomImageNames = []
            break;
          }
        }
      }
      if (isAllBedroomImages == true && this.entranceImages.length > 0 && this.livingRoomImages.length > 0 && this.kitchenImages.length > 0 && this.washroomImages.length) {
        this.shared.isLoader = true
        let category_type: any;
        let files: any
        if (this.entranceImages) {
          category_type = 1
          files = this.entranceImages
          const formData = new FormData();
          formData.append("property_id", this.currentPropertyId);
          formData.append("category_type", category_type);
          for (let t of files) {
            formData.append("files", t.file);
          }
          this.apiService.isUploadImage = true;
          let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CREATE_PROPERTY_STEP5, formData)
          if (res && !res.error) {
            error = false
          }
        }
        if (this.livingRoomImages) {
          category_type = 2
          files = this.livingRoomImages
          const formData = new FormData();
          formData.append("property_id", this.currentPropertyId);
          formData.append("category_type", category_type);
          for (let t of files) {
            formData.append("files", t.file);
          }
          this.apiService.isUploadImage = true;
          let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CREATE_PROPERTY_STEP5, formData)
          if (res && !res.error) {
            error = false
          }
        }
        if (this.kitchenImages) {
          category_type = 3
          files = this.kitchenImages
          const formData = new FormData();
          formData.append("property_id", this.currentPropertyId);
          formData.append("category_type", category_type);
          for (let t of files) {
            formData.append("files", t.file);
          }
          this.apiService.isUploadImage = true;
          let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CREATE_PROPERTY_STEP5, formData)
          if (res && !res.error) {
            error = false
          }
        }
        if (availBedroomImageNames && availBedroomImageNames.length > 0) {
          for (let i of availBedroomImageNames) {
            category_type = category_type = parseInt(i.match(/\d+$/)[0]) + 3
            console.log("category_type", category_type)
            files = this[i]
            const formData = new FormData();
            formData.append("property_id", this.currentPropertyId);
            formData.append("category_type", category_type);
            for (let t of files) {
              formData.append("files", t.file);
            }
            this.apiService.isUploadImage = true;
            let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CREATE_PROPERTY_STEP5, formData)
            if (res && !res.error) {
              error = false
            }
          }

        }
        if (this.washroomImages) {
          category_type = 12
          files = this.washroomImages
          const formData = new FormData();
          formData.append("property_id", this.currentPropertyId);
          formData.append("category_type", category_type);
          for (let t of files) {
            formData.append("files", t.file);
          }
          this.apiService.isUploadImage = true;
          let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CREATE_PROPERTY_STEP5, formData)
          if (res && !res.error) {
            error = false
          }
        }
        console.log("this._communityImages",this.communityImages)
        if (this.communityImages && this.communityImages.length>0) {
          category_type = 14
          files = this.communityImages
          const formData = new FormData();
          formData.append("property_id", this.currentPropertyId);
          formData.append("category_type", category_type);
          for (let t of files) {
            console.log("t", t)
            formData.append("files", t.file);
          }
          this.apiService.isUploadImage = true;
          let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CREATE_PROPERTY_STEP5, formData)
          if (res && !res.error) {
            error = false
          }
        }
      } else {
        error = true
      }
    }
    console.log("error", error)
    if (error == true) {
      this.isImageError = true
    } else {
      this.shared.isLoader = false

    }
  }
  async onSubmitGallary() {
    this.isImageError = false
    this.isgallaryFormSubmit = true;
    console.log("this.entranceImages",this.entranceImages)
    if (this.proertydetailsForm.value.property_construction_type == 2) {
      console.log("inside if")
      if (this.brochureImages.length == 0 || this.entranceImages.length == 0) {
        console.log("inside if")

        if(this.shared.userData.id != this.adminUserID) {
          this.isImageError = true
        }

        console.log("this.isImageError",this.isImageError)
      }
    } else {
      let isAllBedroomImages: any = false
      let availBedroomImageNames: any = []
      if (this.bedroomSelectedOption && this.bedroomSelectedOption.length > 0) {
        console.log("bedroomSelectedOption", this.bedroomSelectedOption)
        for (let i of this.bedroomImageCategory.slice(0, this.bedroomSelectedOption)) {
          console.log("i", i)
          if (this['bedroomImages' + i.id] && this['bedroomImages' + i.id].length > 0) {
            availBedroomImageNames.push('bedroomImages' + i.id)
            isAllBedroomImages = true
          } else {
            isAllBedroomImages = false
            availBedroomImageNames = []
            break;
          }
        }
      } else {
        isAllBedroomImages = true
      }
      if (isAllBedroomImages == true && this.entranceImages.length > 0 && this.livingRoomImages.length > 0 && this.kitchenImages.length > 0 && this.washroomImages.length) {
        this.isImageError = false
      } else {
        this.isImageError = true
      }
    }
    console.log("this.isImageError", this.isImageError);
    if(this.shared.userData.id == this.adminUserID) {
      this.isImageError = false;
    }
    if (!this.isImageError) {
      this.is_terms_modal = true
    }
  }

  async onAgree() {
    this.shared.isLoader = true
    this.onGallary_details()
    let is_error = true
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.UPDATE_IS_ALL_STEP_COMPLETE, {
      "id": this.currentPropertyId,
      "is_all_step_complete": 1
    })
    if (res && !res.error) {
      is_error = false
    } else {
      is_error = true
    }

    if (!this.is_edit_property) {
      let count_res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.UPDATE_PROPERTY_COUNT, {
        id: this.currentPropertyId
      })
      if (count_res && !count_res.error) {
        is_error = false
      } else {
        is_error = true
      }
    }
    if (!is_error) {
      this.shared.isLoader = false
      this.is_terms_modal = false
      this.isAllStepDone = true
    }
  }

  oprenTerm(){
    this.is_terms_modal = true
  }

  closeTremsModal(){
    this.is_terms_modal = false
  }

  // Additional Information

  async onAddInfo_details() {
    this.AddInfosubmit = true;
    console.log(this.addinfoForm);
    if (this.addinfoForm.valid) {
      this.isRemarkModal = true
    }
  }


  onMenu(menu: any) {
    this.activeTab = menu
  }

  onBack(menu: any) {
    this.activeTab = menu
  }

  async getData() {
    let res = await this.apiService.GET_apiRequest(configuration.ENDPOINT.CITY_LIST);
    if (res && !res.error && res.data && res.data.rows) {
      this.cityOptions = res.data.rows
    }
  }

  async onSelectCity(event: any) {
    let city_id = event.target.value;
    if (city_id) {
      let res = await this.apiService.GET_apiRequest(configuration.ENDPOINT.LANDMARK_LIST_CITY_WISE + "/" + city_id);
      if (res && !res.error && res.data && res.data.rows) {
        this.landmarkListMain = res.data.rows
        this.landmarkList = res.data.rows
      }
    }
  }

  onPropertyFileSelected(event: any): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      // You can handle the selected file here, e.g., upload it or update your form control
      this.gallaryForm.patchValue({
        add_photos: file
      });
    }
  }

  async onFileSelected(event: any, type: string) {
    if (type == 'property') {
      this._propertyImages = [...event.target.files];
      for (let i = 0; i < event.target.files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.propertyImages.push(e.target.result);
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    } else if (type == 'entrance') {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.entranceImages.push({
            isImage: file.type.startsWith('image/'),
            file: file,
            result: e.target.result
          });
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    } else if (type == 'livingRoom') {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.livingRoomImages.push({
            isImage: file.type.startsWith('image/'),
            file: file,
            result: e.target.result
          });
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    } else if (type == 'kitchen') {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.kitchenImages.push({
            isImage: file.type.startsWith('image/'),
            file: file,
            result: e.target.result
          });
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    } else if (type.startsWith('bedroomImages')) {
      // console.log("type", type)
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this[type].push({
            isImage: file.type.startsWith('image/'),
            file: file,
            result: e.target.result
          });
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
    else if (type == 'washroom') {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.washroomImages.push({
            isImage: file.type.startsWith('image/'),
            file: file,
            result: e.target.result
          });
        };
        reader.readAsDataURL(event.target.files[i]);
        console.log("this.washroomImages",this.washroomImages)
      }
    } else if (type === 'community') {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.communityImages.push({
            isImage: file.type.startsWith('image/'),
            file: file,
            result: e.target.result
          });
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    } else if (type === 'residential') {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.residentialImages.push({
            isImage: file.type.startsWith('image/'),
            file: file,
            result: e.target.result
          });
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    } else if (type === 'brochure' && this.proertydetailsForm.value.property_construction_type == '2') {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.brochureImages.push({
            isImage: file.type.startsWith('image/'),
            file: file,
            result: e.target.result
          });
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  onFileChange(event: any) {
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.deedImages.push({
          isImage: file.type.startsWith('image/'),
          file: file,
          result: e.target.result
        });
      };
      reader.readAsDataURL(file);
    }
    console.log("this.deedImages",this.deedImages)
  }

  onFloorFileChange(event: any) {
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.floorImages.push({
          isImage: file.type.startsWith('image/'),
          file: file,
          result: e.target.result
        });
      };
      reader.readAsDataURL(event.target.files[i]);
    }

  }

  async deleteFloorImage(index: any) {
    if (this.floorImages[index].fromAPI) {
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.DELETE_DEED, {
        images: this.floorImages[index].result,
        property_id: this.currentPropertyId
      })
    }
    this.floorImages.splice(index, 1);
  }

  async deleteDeedImage(index: any) {
    if (this.deedImages[index].fromAPI) {
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.DELETE_DEED, {
        images: this.deedImages[index].result,
        property_id: this.currentPropertyId
      })
    }
    this.deedImages.splice(index, 1);
  }

  async deleteImage(index: any, type: any) {
    if (type == 'property') {
      this.propertyImages.splice(index, 1);
      console.log("Updated propertyImages:", this.propertyImages);
    } else if (type == 'entrance') {
      if(this.entranceImages && this.entranceImages[index]){
        if(this.entranceImages[index].fromAPI){
          this.deleteImageApi(this.entranceImages[index].result,1)
        }
      }
      this.entranceImages.splice(index, 1);
    } else if (type == 'livingRoom') {
      if(this.livingRoomImages && this.livingRoomImages[index]){
        if(this.livingRoomImages[index].fromAPI){
          this.deleteImageApi(this.livingRoomImages[index].result,1)
        }
      }
      this.livingRoomImages.splice(index, 1);
    } else if (type == 'kitchen') {
      if(this.kitchenImages && this.kitchenImages[index]){
        if(this.kitchenImages[index].fromAPI){
          this.deleteImageApi(this.kitchenImages[index].result,1)
        }
      }
      this.kitchenImages.splice(index, 1);
    } else if (type.startsWith('bedroomImages')) {
      console.log(type +  ":" , type.charAt(type.length - 1))
      let category_type = Number(type.charAt(type.length - 1)) + 3
      if(this[type] && this[type][index]){
        if(this[type][index].fromAPI){
          this.deleteImageApi(this[type][index].result,1)
        }
      }
      this[type].splice(index, 1);
    } else if (type == 'washroom') {
      if(this.washroomImages && this.washroomImages[index]){
        if(this.washroomImages[index].fromAPI){
          this.deleteImageApi(this.washroomImages[index].result,1)
        }
      }
      this.washroomImages.splice(index, 1);
    } else if (type == 'community') {
      if(this.communityImages && this.communityImages[index]){
        if(this.communityImages[index].fromAPI){
          this.deleteImageApi(this.communityImages[index].result,1)
        }
      }
      this.communityImages.splice(index, 1);
    } else if (type == 'residential') {
      this.residentialImages.splice(index, 1);
    } else if (type == 'brochure' && this.proertydetailsForm.value.property_construction_type == '2') {
      if(this.brochureImages[index].fromAPI){
          let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.DELETE_BROCHURE, {
            images: this.brochureImages[index].result,
            property_id: this.currentPropertyId
          })
      }
      this.brochureImages.splice(index, 1);
    }
  }

  async submitForm(featured_status: any) {

    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CREATE_PROPERTY_STEP6, {
      "id": this.currentPropertyId,
      "ownership_type": this.addinfoForm.value.ownership_type,
      "is_title_deed_certificate": this.proertydetailsForm.value.property_construction_type == '1' ? this.addinfoForm.value.is_title_deed_certificate : null,
      "is_spa": this.proertydetailsForm.value.property_construction_type == '2' ? this.addinfoForm.value.is_spa : null,
      "is_featured": featured_status
    });
    if (res && !res.error) {
      // this.activeTab = 'gallary'
      this.isRemarkModal = false
      this.router.navigate(['/properties']);
    }
  }

  async deleteImageApi(name :any,category_type : any){
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.DELETE_PROPERTY_IMAGE, {
      images : name,
      property_id : this.currentPropertyId,
      category_type : category_type
    })
    if(res && !res.error){

    }
  }

  getBedroomImages(id: any) {
    return this['bedroomImages' + id];
  }

  onSubmitPropertyPage(){
    window.location.href = '/create-property'
  }
  onHomePage(){
    window.location.href = '/'
  }
  
  searchCity(e:any) {
    this.landmarkList = [];
    let value = e.target.value.trim().toLowerCase();
    if(value != "") {
      for(let c of this.landmarkListMain) {
        if(c.landmark_name.toLowerCase().indexOf(value) >= 0) {
          this.landmarkList.push(c);
        }
      }
    } else {
      this.landmarkList = JSON.parse(JSON.stringify(this.landmarkListMain));
    }

  }

}
